import { gql, useQuery } from "utils/urql";
import ArticleRecirc from "./ArticleRecirc";
import { RelatedContentQuery, RelatedContentQueryVariables } from "types/api";

const RELATED_CONTENT_QUERY = gql`
  ${ArticleRecirc.fragment}

  query RelatedContentQuery($id: ID!, $preview: String) {
    relatedContent(id: $id, preview: $preview) {
      displayName
      river(first: 3) {
        ...articleRecirc
      }
    }
  }
`;

const RelatedContentDisplay = ({
  id,
  position,
  preview,
}: {
  id: string;
  position: string;
  preview?: string | null;
}) => {
  const [{ data }] = useQuery<
    RelatedContentQuery,
    RelatedContentQueryVariables
  >({
    query: RELATED_CONTENT_QUERY,
    variables: {
      id,
      preview,
    },
  });
  const content = data?.relatedContent;
  if (!content?.river?.edges.length) return null;
  return (
    <ArticleRecirc
      displayName={content.displayName}
      articles={content.river}
      showImages={true}
      position={position}
    />
  );
};

export default RelatedContentDisplay;
